// extracted by mini-css-extract-plugin
export default {"column":"TopicFilesEditComponent_column__56E80","body":"TopicFilesEditComponent_body__T4jZt"};